import React, { useState } from 'react';
import { SizeSelector } from './SizeSelector';
import { AddToCartButton } from './AddToCartButton';
import { StarIcon } from 'lucide-react';
import { Toast } from './Toast';
import { useCart } from '../context/CartContext';
interface ProductDetailsProps {
  name: string;
  description: string;
  price: number;
  sku: string;
  image: string;
}
export const ProductDetails: React.FC<ProductDetailsProps> = ({
  name,
  description,
  price,
  sku,
  image
}) => {
  const [selectedSize, setSelectedSize] = useState('');
  const [toastVisible, setToastVisible] = useState(false);
  const {
    addItem
  } = useCart();
  const sizes = ['XS', 'S', 'M', 'L', 'XL'];
  const handleAddToCart = () => {
    if (!selectedSize) return;
    addItem({
      name,
      price,
      size: selectedSize,
      image
    });
    setToastVisible(true);
  };
  return <div className="w-full lg:w-1/2 lg:pl-10" data-id="element-187">
      <Toast message={`${name} (${selectedSize}) added to your bag!`} isVisible={toastVisible} onClose={() => setToastVisible(false)} type="success" data-id="element-188" />
      <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl" data-id="element-189">{name}</h1>
      <div className="mt-2 flex items-center" data-id="element-190">
        <div className="flex items-center" data-id="element-191">
          {[0, 1, 2, 3, 4].map(rating => <StarIcon key={rating} className={`h-5 w-5 ${rating < 4 ? 'text-yellow-400' : 'text-gray-300'}`} aria-hidden="true" data-id="element-192" />)}
        </div>
        <p className="ml-3 text-sm text-gray-500" data-id="element-193">42 reviews</p>
      </div>
      <div className="mt-4" data-id="element-194">
        <p className="text-2xl font-medium text-gray-900" data-id="element-195">
          ${price.toFixed(2)}
        </p>
        <p className="mt-1 text-sm text-gray-500" data-id="element-196">
          Free shipping on all orders
        </p>
      </div>
      <div className="mt-6 border-t border-gray-200 pt-6" data-id="element-197">
        <p className="text-base text-gray-900 space-y-4 leading-relaxed" data-id="element-198">
          {description}
        </p>
      </div>
      <div className="mt-6" data-id="element-199">
        <div className="flex items-center" data-id="element-200">
          <div className="h-6 w-6 rounded-full bg-black border border-gray-300" data-id="element-201"></div>
          <p className="ml-2 text-sm font-medium text-gray-900" data-id="element-202">Black</p>
        </div>
      </div>
      <SizeSelector sizes={sizes} selectedSize={selectedSize} onSizeChange={setSelectedSize} data-id="element-203" />
      <AddToCartButton disabled={!selectedSize} onClick={handleAddToCart} data-id="element-204" />
      <div className="mt-6" data-id="element-205">
        <p className="text-xs text-gray-500" data-id="element-206">SKU: {sku}</p>
      </div>
      <div className="mt-8 border-t border-gray-200 pt-6" data-id="element-207">
        <div className="space-y-6" data-id="element-208">
          <div data-id="element-209">
            <h3 className="text-sm font-medium text-gray-900" data-id="element-210">Features</h3>
            <ul className="mt-2 list-disc pl-4 text-sm text-gray-500 space-y-1" data-id="element-211">
              <li data-id="element-212">Ultra-soft fabric blend</li>
              <li data-id="element-213">Moisture-wicking technology</li>
              <li data-id="element-214">Four-way stretch for maximum mobility</li>
              <li data-id="element-215">Flatlock seams to prevent chafing</li>
              <li data-id="element-216">UPF 50+ sun protection</li>
            </ul>
          </div>
          <div data-id="element-217">
            <h3 className="text-sm font-medium text-gray-900" data-id="element-218">
              Care Instructions
            </h3>
            <ul className="mt-2 list-disc pl-4 text-sm text-gray-500 space-y-1" data-id="element-219">
              <li data-id="element-220">Machine wash cold with like colors</li>
              <li data-id="element-221">Do not bleach</li>
              <li data-id="element-222">Tumble dry low</li>
              <li data-id="element-223">Do not iron</li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
};